import * as React from 'react';
import { ModalMain } from 'damco-components';

export interface IInvoiceValidationError {
    field: string;
    message: string;
    action: string;
    reason: string;
    resolution: string;
    documentNumber: string;
    documentId: number;
    category: string;
}

interface IProps {
    displayDialog: boolean;
    errors: IInvoiceValidationError[];
    isDestination?: boolean;
    closeDialog: () => void;
}

export const InvoiceValidationModal = (props: IProps) => {
    if (!props.displayDialog || !props.errors || props.errors.length === 0) {
        return null;
    }
    const jobLabel = props.isDestination ? 'ETS job' : 'export job';
    const totalIssues = props.errors.length;

    return (
        <ModalMain
            height={400}
            modal={props.displayDialog}
            title={'Operation not possible'}
            hideMethod={props.closeDialog}
            secondaryMethod={props.closeDialog}
            primaryMethod={props.closeDialog}
            btnTitle1={'OK'}
            btnTitle2={'CLOSE'}
        >
            <div className="invoice-validation-modal">
                <p className="invoice-validation-summary">
                    <strong>
                        Invoice cannot be generated for the {jobLabel}. {totalIssues} validation issue(s) found.
                    </strong>
                </p>
                <ul className="invoice-validation-error-list">
                    {props.errors.map((error) => (
                        <li key={`${error.documentId}-${error.field}-${error.message}`} className="invoice-validation-error-item">
                            <span className="invoice-validation-error-message">{error.message}</span>
                            {error.resolution && (
                                <span className="invoice-validation-error-resolution">
                                    {' — '}{error.resolution}
                                </span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </ModalMain>
    );
};
